import { render } from "./ContactsView.vue?vue&type=template&id=c87d43e2&ts=true"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__